import actions from '@/store/modules/subordinatesWorkload/actions';
import mutations from '@/store/modules/subordinatesWorkload/mutations';
// import SubordinatesConstants from '@/store/modules/subordinatesWorkload/constants';

const state = {
  subordinatesLoading: false,
  subordinateInfoLoading: false,
  updatingSubscription: false,
  subordinatesClientsLoading: false,
  showSideBar: true,
  selectedSubordinateId: null,
  subordinates: [],
  subordinatesTotal: 0,
  selectedSubordinateInfo: null,
  subordinatesClients: [],
};

const getters = {
  // [SubordinatesConstants.getterTypes.selectedSubordinateClients](localState) {
  //   return localState.selectedSubordinateInfo.;
  // },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
